import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    hourly: {
        loading: true,
        data: {},
        error: null,
    },
    daily: {
        loading: true,
        data: {},
        error: null,
    },
    selectedUser: null, 
}

export const userCallReportSlice = createSlice({
    name: 'userCallReport',
    initialState,
    reducers: {
        setUserCallReportLoading: (state, action) => {
            const { timeframe } = action.payload;
            state[timeframe].loading = true;
        },
        setUserCallReport: (state, action) => {
            const { timeframe, data } = action.payload;
            state[timeframe].loading = false;
            state[timeframe].data = data;
            state[timeframe].error = null;
        },
        resetUserCallReport: () => initialState,
    },
});

export const {
    setUserCallReportLoading,
    setUserCallReport,
    resetUserCallReport
} = userCallReportSlice.actions;

export const selectUserCallReportHourly = (state) => state.userCallReport.hourly;
export const selectUserCallReportDaily = (state) => state.userCallReport.daily;

export default userCallReportSlice.reducer;